<template>
  <div>
    <div style="display: none">
      <v-facebook-login v-model="model" :login-options="permisos" :app-id="app_id_facebook" @sdk-init="handleSdkInit" />
    </div>
    <v-icon style="color: black" color="blue" class="text--primary" size="30px" @click="clickFBLogin">
      mdi-facebook
    </v-icon>
    <div style="white-space: pre-line">
      {{ $t('Facebook Log in') }}
    </div>
  </div>
</template>

<script>
import AuthRepository from "../repositories/AuthRepository";
import VFacebookLogin from 'vue-facebook-login-component';
import Constants from "../../constants";
export default {
    name: "LoginFacebook",
    components: {
        VFacebookLogin
    },
    data () {
        return {
            permisos: {scope: "public_profile,email"},
            FB: {},
            model: {},
            scope: {},
            app_id_facebook: Constants.LOGIN_SOCIAL.FACEBOOK_ID
        };
    },
    methods: {
        clickFBLogin: async function () {
            if (!this.model.connected) {
                await this.FB.login(result => {
                    this.fbLogin(result);
                }, {scope: 'email,public_profile'});
            } else {
                this.FB.getLoginStatus((response) => {
                    this.fbLogin(response);
                });
            }
        },
        fbLogin (response) {
            if (response != null && response.status === 'connected') {
                AuthRepository.loginFB(response.authResponse.accessToken)
                    .then(response => {
                        this.$root.$emit('log-facebook', response );
                    }).catch((err) => {
                        console.log(err);
                    });
            } //else if (response == null) console.log("Estas tornant de main i no tens dades");
            //else console.log("No estas connectat ");
        },
        handleSdkInit ({ FB, scope }) {
            this.FB = FB;
            this.scope = scope;
        },
    }
};
</script>

<style scoped>


</style>
